import { lazy } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";

// ─── Lazy-loaded Pages ────────────────────────────────────────────────────────
const HomePage = lazy(() => import("../pages/HomePage"));
// const PrivacyPolicyPage = lazy(() => import("../pages/PrivacyPolicyPage"));
// const TermsOfUsePage = lazy(() => import("../pages/TermsOfUsePage"));
const AboutPage = lazy(() => import("../pages/AboutPage"));
const ServicesPage = lazy(() => import("../pages/ServicesPage"));
const ServiceDetailPage = lazy(() => import("../pages/ServiceDetailPage"));
const IndustriesPage = lazy(() => import("../pages/IndustriesPage"));
const InsightsPage = lazy(() => import("../pages/InsightsPage"));
const ContactPage = lazy(() => import("../pages/ContactPage"));
const CaseStudiesPage = lazy(() => import("../pages/CaseStudiesPage"));
const NotFoundPage = lazy(() => import("../pages/NotFoundPage"));

// ─── Router Configuration ─────────────────────────────────────────────────────
const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "about", element: <AboutPage /> },
      { path: "services", element: <ServicesPage /> },
      { path: "services/:slug", element: <ServiceDetailPage /> },
      { path: "industries", element: <IndustriesPage /> },
      { path: "insights", element: <InsightsPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "case-studies", element: <CaseStudiesPage /> },
    ],
  },
  { path: "/404", element: <NotFoundPage /> },
  { path: "*", element: <Navigate to="/404" replace /> },
]);

export default router;
